module.exports = __webpack_public_path__ + "img/SEJ_Eventos_cuadricula de respuesta.fe834e1e.svg";